"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.message = exports.date = exports.number = void 0;
exports.setNumber = setNumber;
exports.setDate = setDate;
exports.setMessage = setMessage;
const invariant_1 = __importDefault(require("./invariant"));
const lodash_1 = require("lodash");
const simple_number_localizer_1 = require("../localizers/simple-number-localizer");
const simple_date_localizer_1 = require("../localizers/simple-date-localizer");
const simple_message_localizer_1 = require("../localizers/simple-message-localizer");
function emptyLocalizer(props) {
    var _a, _b;
    const empty = {};
    if (((_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) !== 'production') {
        props
            .forEach((name) => Object.defineProperty(empty, name, {
            enumerable: true,
            get() {
                throw new Error('[adp-react-components] You are attempting to use a widget that requires localization.' +
                    'However there is no localizer set. Please configure a localizer.' +
                    'Missing localizer method: ' + name);
            }
        }));
    }
    return empty;
}
const REQUIRED_NUMBER_FORMATS = ['default'];
const REQUIRED_DATE_FORMATS = [
    'default',
    'date',
    'time',
    'header',
    'footer',
    'dayOfMonth',
    'month',
    'year',
    'decade',
    'century'
];
function _format(localizer, formatter, value, format, locale) {
    const result = typeof format === 'function' ? format(value, locale, localizer) : formatter.call(localizer, value, format, locale);
    (0, invariant_1.default)(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
    return result;
}
function checkFormats(requiredFormats, formats) {
    var _a, _b;
    if (((_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) !== 'production') {
        requiredFormats.forEach((f) => (0, invariant_1.default)((0, lodash_1.has)(formats, f), 'localizer missing required format: `%s`', f));
    }
}
let _numberLocalizer = emptyLocalizer(['formats', 'parse', 'format', 'precision', 'decimalChar']);
function setNumber(localizer) {
    const { format, parse, formats } = localizer;
    let { precision, decimalChar } = localizer;
    (0, invariant_1.default)(typeof format === 'function', 'number localizer `format(..)` must be a function');
    (0, invariant_1.default)(typeof parse === 'function', 'number localizer `parse(..)` must be a function');
    checkFormats(REQUIRED_NUMBER_FORMATS, formats);
    formats.editFormat = formats.editFormat || ((str) => parseFloat(str));
    precision = precision || (() => null);
    decimalChar = decimalChar || (() => '.');
    _numberLocalizer = {
        formats,
        precision,
        decimalChar,
        format(value, str, locale) {
            return _format(this, format, value, str, locale);
        },
        parse(value, locale, formatStr) {
            const result = parse.call(this, value, locale, formatStr);
            (0, invariant_1.default)(result == null || typeof result === 'number', 'number localizer `parse(..)` must return a number, null, or undefined');
            return result;
        }
    };
}
let _dateLocalizer = emptyLocalizer(['formats', 'parse', 'format', 'firstOfWeek', 'startOfWeek']);
function setDate(localizer) {
    const { format, parse, formats, startOfWeek } = localizer;
    (0, invariant_1.default)(typeof format === 'function', 'date localizer `format(..)` must be a function');
    (0, invariant_1.default)(typeof parse === 'function', 'date localizer `parse(..)` must be a function');
    (0, invariant_1.default)(typeof startOfWeek === 'function', 'date localizer `startOfWeek(..)` must be a function');
    checkFormats(REQUIRED_DATE_FORMATS, formats);
    _dateLocalizer = {
        formats,
        startOfWeek,
        format(value, str, locale) {
            return _format(this, format, value, str, locale);
        },
        parse(value, formatStr, locale) {
            const result = parse.call(this, value, formatStr, locale);
            (0, invariant_1.default)(result == null || (result instanceof Date && !isNaN(result.getTime())), 'date localizer `parse(..)` must return a valid Date, null, or undefined');
            return result;
        }
    };
}
let _messageLocalizer = emptyLocalizer(['formatMessage']);
function setMessage(localizer) {
    const { formatMessage } = localizer;
    (0, invariant_1.default)(typeof formatMessage === 'function', 'message localizer `formatMessage(..)` must be a function');
    _messageLocalizer = {
        formatMessage
    };
}
setNumber((0, simple_number_localizer_1.simpleNumberLocalizer)());
setDate((0, simple_date_localizer_1.simpleDateLocalizer)());
setMessage((0, simple_message_localizer_1.simpleMessageLocalizer)());
exports.number = {
    getFormat(key, format) {
        return format || _numberLocalizer.formats[key];
    },
    parse(num, locale, format) {
        return _numberLocalizer.parse(num, locale, format);
    },
    format(num, format, locale) {
        return _numberLocalizer.format(num, format, locale);
    },
    decimalChar(format, locale) {
        return _numberLocalizer.decimalChar(format, locale);
    },
    precision(format, locale) {
        return _numberLocalizer.precision(format, locale);
    }
};
exports.date = {
    getFormat(key, format) {
        return format || _dateLocalizer.formats[key];
    },
    parse(dateStr, format, locale) {
        return _dateLocalizer.parse(dateStr, format, locale);
    },
    format(dateVal, format, locale) {
        return _dateLocalizer.format(dateVal, format, locale);
    },
    startOfWeek(locale) {
        return _dateLocalizer.startOfWeek(locale);
    }
};
exports.message = {
    formatMessage(path, variables, locale) {
        return _messageLocalizer.formatMessage(path, variables, locale);
    }
};
exports.default = { number: exports.number, date: exports.date, message: exports.message };
//# sourceMappingURL=localizers.js.map